import { DotLegalPaper } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import ClassificationTable from "../../../legalEntity/legalEntityClassificationTab/classificationTable/ClassificationTable";
import useProcessingActivityClassificationTabHooks from "./ProcessingActivityClassificationTab.hooks";
import { useTranslation } from "../../../localization/useTranslation";

export interface IProcessingActivityClassificationTabProps {
    processingActivityId: string;
    onClassificationsChanged: () => void;
}

function ProcessingActivityClassificationTab(props: IProcessingActivityClassificationTabProps) {
    const { translateString } = useTranslation();
    const { isLoading, data, refetch } = useProcessingActivityClassificationTabHooks(props);

    return (
        <DotLegalPaper>
            <React.Fragment>
                <ClassificationTable
                    data={data}
                    isLoading={isLoading}
                    refetch={() => {
                        refetch();
                        props.onClassificationsChanged();
                    }}
                    pageType="processingActivity"
                    emptyStateText={translateString("noClassifications")}
                    sessionStorageKey={`processing-activity-${props.processingActivityId}-classifications-filters`}
                />
            </React.Fragment>
        </DotLegalPaper>
    );
}

export default ProcessingActivityClassificationTab;
